import { isNil } from 'lodash';

const isNonNullable = <T>(v: T): v is NonNullable<T> => !isNil(v);

export default isNonNullable;
